import { useEffect } from 'react';

import { PintoEbookCollectionQuery } from '../../../core/graphql/types';
import useQueryPintoEbookCollectionItems from '../../../hooks/useQueryPintoEbookCollectionItems';
import { PINTO_BOOK_BASE_URL } from '../../ebooks/presenters/AboutDetailPresenter';

export interface IKOLCoverImagesPresenterProps {
  collectionData: NonNullable<PintoEbookCollectionQuery['pintoEbookCollection']>;
}

function KOLCoverImagesPresenter(props: IKOLCoverImagesPresenterProps) {
  const { collectionData } = props;
  const kolId = collectionData._id;
  const { fetchPintoEbookCollectionItems, pintoEbookCollectionItems, isLoadingPintoEbookCollectionItems } = useQueryPintoEbookCollectionItems();

  useEffect(() => {
    if (kolId) {
      fetchPintoEbookCollectionItems(kolId);
    }
  }, [kolId, fetchPintoEbookCollectionItems]);

  return (
    <div className="p-24 space-y-24 bg-componentsBgGrouped02 rounded-lg">
      <h2 className="font-dbh text-[20px]">Cover Images</h2>

      <div className="space-y-16">
        <div>
          <label className="text-sm font-medium text-colorsBrandWarmBlack02LabelSecondary">OG Image</label>
          <div className="mt-8">
            {collectionData.ogImageUrl ? (
              <div className="w-full md:w-[730px] h-[310px] bg-colorsBrandWarmBlack04LabelQuaternary rounded-6">
                {collectionData.ogImageUrl && <img alt="OG Image" className="w-full md:w-[730px] h-[310px] rounded-6 object-cover" src={collectionData.ogImageUrl || ''} />}
              </div>
            ) : (
              <p className="font-tt text-colorsBrandWarmBlack02LabelSecondary">No OG image available</p>
            )}
          </div>
        </div>

        <div>
          <label className="text-sm font-medium text-colorsBrandWarmBlack02LabelSecondary">Ebook Cover Images</label>
          <div className="mt-8 flex space-x-12 space-y-4">
            {isLoadingPintoEbookCollectionItems ? null : pintoEbookCollectionItems && pintoEbookCollectionItems.edges.length > 0 ? (
              pintoEbookCollectionItems.edges.map((edge, index) => (
                <div key={edge.node._id} className="relative">
                  <a target="_blank" className="block" href={`${PINTO_BOOK_BASE_URL}/ebooks/${edge.node._id}`} rel="noreferrer">
                    <img src={edge.node.coverImageUrl || ''} alt={edge.node._id || ''} className="w-[44px] h-[60px] rounded object-cover" />
                  </a>
                  <div className="absolute top-0 left-0 bg-black bg-opacity-50 text-white text-xs px-2 py-1 rounded">{index + 1}</div>
                </div>
              ))
            ) : (
              <p className="font-tt text-colorsBrandWarmBlack02LabelSecondary col-span-full">No cover images available</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default KOLCoverImagesPresenter;
